const helpContext = {
  HOME: 'Home',
  PROJECTS: 'Projects',
  OPEN_PROJECT: 'Openproject',
  COURSE_BUILDER: 'Coursebuilder',
  COURSE_BUILDER_DESIGN: 'CBdesign',
  COURSE_BUILDER_COMPETENCY: 'CBcompetency',
  COURSE_BUILDER_SCORING: 'CBscoring',
  LESSON_BUILDER: 'Lessonbuilder',
  LESSON_BUILDER_DESIGN: 'LBdesign',
  LESSON_BUILDER_COMPETENCY: 'LBcomptency',
  LESSON_BUILDER_SCORING: 'LBscoring',
  SCREEN_EDITOR: 'Screeneditor',
  KNOWLEDGE: 'Knowledge',
  CLASSES: 'Classes',
};

export default helpContext;
